import get from 'lodash/get';

import * as consts from './constants';

export const isIdle = (status) => !status || status === consts.IDLE;
export const isBusy = (status) => status === consts.PENDING;
export const isLoading = (status) => isBusy(status);
export const isLoaded = (status) => status === consts.SUCCEEDED;

const selectActionData = ({ state, actionName, attribute, actionUid }) =>
  get(state, [actionName.toString(), actionUid, attribute], null);

export const selectActionStatus = (
  { actionStatus: state },
  actionName,
  actionUid = consts.ALL_RESOURCES,
) => selectActionData({ state, actionName: actionName.toString(), actionUid, attribute: 'status' });

export const selectActionErrors = (
  { actionStatus: state },
  actionName,
  actionUid = consts.ALL_RESOURCES,
) => selectActionData({ state, actionName: actionName.toString(), actionUid, attribute: 'errors' });

export const selectActionMeta = (
  { actionStatus: state },
  actionName,
  actionUid = consts.ALL_RESOURCES,
) => selectActionData({ state, actionName: actionName.toString(), actionUid, attribute: 'meta' });
